import { TFunction } from 'i18next';

export const popupData = (
  t: TFunction,
  popupToggle: () => void,
  isUnblocking: boolean,
  unblock: () => Promise<void>,
  closePopup: () => Promise<void>
) => {
  return {
    blockedByYou: {
      title: t('pages.ad.you_blocked_user'),
      description: t('pages.ad.unblock_to_continue'),
      actions: {
        left: {
          isGray: true,
          text: t('common.deny'),
          onClick: popupToggle,
          disabled: isUnblocking,
        },
        right: {
          text: t('common.unblock'),
          onClick: unblock,
          disabled: isUnblocking,
        },
      },
    },
    blockedByOtherUser: {
      title: t('pages.ad.user_unavailable'),
      description: t('pages.ad.user_restricts_access'),
      actions: { left: { text: t('common.ok'), onClick: closePopup } },
    },
  };
};
